import React from "react";
import { IStoredSearchQueryProps } from "../../types/suggestion-items";
import { useNavigationContext } from "../../util/contexts";
import { setStoredSearchQuery } from "../../util/queryStorage";

const StoredSearchQuery = (props: IStoredSearchQueryProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();
    const trackingId = "ssw-zq-last-search";

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.storedQuery.navIndex);
        setStoredSearchQuery({ name: props.storedQuery.value, target: props.storedQuery.target });
        window.location.href = props.storedQuery.target;
    };

    return props.storedQuery.isHeadline ? (
        <li
            className={"last-search-query-text not-selectable"}
            key={props.storedQuery.navIndex}
            ref={props.setRef}
        >
            {props.storedQuery.value}
        </li>
    ) : (
        <li
            className={"last-search-query-item"}
            key={props.storedQuery.navIndex}
            ref={props.setRef}
            onMouseEnter={() => handleMouseSelect(props.storedQuery.navIndex)}
            onMouseLeave={handleMouseDeselect}
        >
            <a
                href={props.storedQuery.target}
                onClick={handleClick}
                data-testid={`${trackingId}-${props.storedQuery.anchorIndex}`}
                data-semantic-id={`${trackingId}-${props.storedQuery.anchorIndex}`}
            >
                {props.storedQuery.value}
            </a>
        </li>
    );
};

export default StoredSearchQuery;
